import MoveAssignmentToLessonAsyncRequestModelBase from '../_generated/modelBases/move-assignment-to-lesson-async-request-model-base';

export default class MoveAssignmentToLessonAsyncRequestModel extends MoveAssignmentToLessonAsyncRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
